import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ActionButton } from '@/components/ui+/ActionButton';
import { FloorPlanEditor } from './FloorPlanEditor';

export const Route = createFileRoute('/r/$restaurantId/s/floor-plans')({
  component: Component,
});

function Component() {
  const { restaurantId } = Route.useParams();
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && <FloorPlanEditor restaurantId={restaurantId} onClose={() => setOpen(false)} />}

      <Card>
        <CardHeader>
          <CardTitle>Floor plans</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Setup a visual floor plan to assign orders to tables.
          </p>
          <ActionButton variant="outline" onClick={() => setOpen(true)}>
            Edit floor plan
          </ActionButton>
        </CardContent>
      </Card>
    </>
  );
}
